import type { ColumnDef } from '@tanstack/react-table';

import { DataTableColumnHeader } from '@/components/dataTable/ColumnHeader';
import { PointsBalanceStatementData } from '@/services/pointsBalanceStatement/pointsBalanceStatement.types';
import { useDynamicLocale } from '@/hoslog-intl';

export function getColumns(t: ReturnType<typeof useDynamicLocale>['t']): ColumnDef<PointsBalanceStatementData>[] {
  return [
    {
      accessorKey: 'sn',
      header: ({ column }) => <DataTableColumnHeader column={column} title={t('common.page.tableColumn.sn')} />,
      cell: ({ row }) => <div className="font-medium truncate max-w-[10rem]">{row.getValue('sn')}</div>,
      enableSorting: false,
    },
    {
      accessorKey: 'transactionId',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Transaction ID" />,
      cell: ({ row }) => <div className="font-medium truncate max-w-[20rem]">{row.getValue('transactionId')}</div>,
      meta: {
        label: 'Transaction ID',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'transactionDate',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Transaction Date" />,
      cell: ({ row }) => <div>{row.getValue('transactionDate')}</div>,
      meta: {
        label: 'Transaction Date',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'transactionType',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Transaction Type" />,
      cell: ({ row }) => <div>{row.getValue('transactionType')}</div>,
      meta: {
        label: 'Transaction Type',
      },
      enableHiding: false,
    },

    {
      accessorKey: 'totalClubs',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Total Clubs" />,
      cell: ({ row }) => <div>{row.getValue('totalClubs')}</div>,
      meta: {
        label: 'Total Clubs',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'user',
      header: ({ column }) => <DataTableColumnHeader column={column} title="User" />,
      cell: ({ row }) => <div>{row.getValue('user')}</div>,
      meta: {
        label: 'User',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'totalPrice',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Total Price" />,
      cell: ({ row }) => <div>{row.getValue('totalPrice')}</div>,
      meta: {
        label: 'Total Price',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'totalCommissionAmt',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Total Commission Amt" />,
      cell: ({ row }) => <div>{row.getValue('totalCommissionAmt')}</div>,
      meta: {
        label: 'Total Commission Amt',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'remarks',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Remarks" />,
      cell: ({ row }) => <div>{row.getValue('remarks')}</div>,
      meta: {
        label: 'Remarks',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'debit',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Debit" />,
      cell: ({ row }) => <div>{row.getValue('debit')}</div>,
      meta: {
        label: 'Debit',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'credit',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Credit" />,
      cell: ({ row }) => <div>{row.getValue('credit')}</div>,
      meta: {
        label: 'Credit',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'balance',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Balance" />,
      cell: ({ row }) => <div>{row.getValue('balance')}</div>,
      meta: {
        label: 'Balance',
      },
      enableHiding: false,
    },
  ];
}
